import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';

type RouteWithTitleProps = {
  component: React.FC<any>;
  exact?: boolean;
  path: string;
  title: string;
};

export const useSetTitleOnLoad = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export const RouteWithTitle = ({
  exact,
  path,
  component: Component,
  title,
}: RouteWithTitleProps) => {
  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => <Component {...props} title={title} />}
    />
  );
};
